import styled from "styled-components";

const GameCardName = styled.p`
  display: flex;
  margin: 2%;
  color: #eee;
  font-weight: 500;
  font-size: 1.2em;
  justify-content: center;
  text-align: center;
`;

export default GameCardName;
